/**
 * Wanneer de nachtelijke controle voor het laatst gedraaid heeft.
 *
 * 'Nooit gedraaid' is een eigen bericht, geen afgeleide van nul meldingen. Een
 * controle die nooit heeft gedraaid levert nul driftmeldingen en een leeg
 * signaleringslijstje op — precies hetzelfde beeld als "alles in orde". Zonder
 * dit blok is dat verschil nergens te zien.
 *
 * AI-CONTEXT: See docs/pitfalls.md#dev-one-off-step-has-no-red-test
 * AI-CONTEXT: See docs/features/intelligence-research-questions.md (§8)
 *
 * @param {object} props
 * @param {(object|null)} props.sweep - het IntelligenceSweeps/current-document
 * @param {boolean} props.neverRan - zeker weten dat de controle nooit gedraaid heeft
 * @param {boolean} props.loading - de read loopt nog
 * @param {(Error|null)} props.error - de read is mislukt
 * @param {boolean} props.busy - een handmatige run is bezig
 * @param {() => void} props.onRun - start de controle handmatig
 */
const SweepStatus = ({ sweep, neverRan, loading, error, busy, onRun }) => {
    const body = () => {
        if (error) {
            return (
                <span className="intelligence-state--error">
                    De controlestatus kon niet worden geladen: {error.message}
                </span>
            )
        }
        if (loading) return <span>Controlestatus laden…</span>
        if (neverRan) {
            return (
                <span className="intelligence-state--error">
                    De controle heeft nog nooit gedraaid. Zolang dat zo is, zegt een lege
                    herbeoordelingslijst niets.
                </span>
            )
        }
        // Geen momentopname en toch niet 'nooit gedraaid': dan weten we het
        // gewoon niet. Niets beweren is hier het enige eerlijke antwoord — en
        // de component mag niet omvallen op een toestand die zijn aanroeper
        // niet had moeten kunnen maken.
        if (!sweep) return <span>Controlestatus onbekend.</span>

        const moment = sweep.ComputedAt ? new Date(sweep.ComputedAt) : null
        return (
            <span>
                Laatst gecontroleerd: {moment ? moment.toLocaleString('nl-NL') : 'onbekend'}
                {' · '}{sweep.Checked || 0} gepubliceerde inzichten
                {sweep.Errors && sweep.Errors.length > 0 && (
                    <span className="intelligence-state--error">
                        {' · '}{sweep.Errors.length} niet kunnen uitrekenen
                    </span>
                )}
            </span>
        )
    }

    return (
        <div className="intelligence-sweep-status">
            {body()}
            <button disabled={busy} onClick={onRun}>
                {busy ? 'Bezig…' : 'Nu controleren'}
            </button>
        </div>
    )
}

export default SweepStatus
